export enum StoreType {
  Delivery = 'delivery',
  Pickup = 'dispensary',
}

export interface SupportedLocation {
  zip_code: string;
}

export interface DispCoordinates {
  lat: number,
  lng: number,
}

export class DispensaryReduced {
  dispId: string;
  deliveryEstimateFrom: string;
  deliveryEstimateTo: string;
  coordinates: DispCoordinates;
}

export class DispensaryDsp {
  dispensary: Dispensary = new Dispensary();
  items: Items[] = [];
  deals: Deals[] = [];
  deal_categories: DealCategories[] = [];
  categories: Category[] = [];
  code: any;
}

export class Dispensary {
  disp_id: string;
  disp_alpha_id: string;
  owner_id: string;
  disp_name: string;
  domain: string;
  logo: string;
  cover: string;
  description: string;
  disp_type: string;
  range_type: string;
  branch: string;
  lat: string;
  lng: string;
  address_label: string;
  short_address: string;
  location_id: string;
  disp_timezone: string;
  fulfillment_time: string;
  is_recurred: string;
  contact_name: string;
  contact_phone: string;
  disp_email: string;
  disp_phone: string;
  facebook: string;
  facebook_id: string;
  instagram: string;
  twitter: string;
  account_id: string;
  created_at: string;
  last_login: string;
  payment_signed: string;
  update_endpoint: string;
  subscription_id: string;
  payment_method: string;
  ipad_serial: string;
  required_sign: string;
  reward_enabled: string;
  tax_enabled: string;
  is_hidden: string;
  is_deleted: string;
  sms_phone: string;
  manager_email: string;
  has_followed: string;
  tax_configs: string;
  reward: string;
  location: DispensaryLocation = new DispensaryLocation();
  open_times: DispensaryOpenTimes[] = [];
  avg_review: DispensaryAvgReview = new DispensaryAvgReview();
}

export class DispensaryLocation {
  location_id: string;
  zip_code: string;
  city: string;
  short_state: string;
}

export class DispensaryOpenTimes {
  day: string;
  from_time: string;
  to_time: string;
}

export class DispensaryAvgReview {
  disp_id: string;
  num_of_reviews: string;
  avg_rate: string;
}

export class DealCategories {
  deal_cat_id: string;
  disp_id: string;
  cat_name: string;
  position: string;
  is_deleted: string;
  deals: Deals[] = [];
  styleClass: any;

}

export class Deals {
  deal_id: string;
  disp_id: string;
  deal_cat_id: string;
  deal_name: string;
  priority: string;
  is_hidden: string;
  is_deleted: string;
  active_days: any[];
}

export class Category {
  cat_id: string;
  attr_id: string;
  cat_type: string;
  menu_item_id: string;
  cat_name: string;
  position: string;
  status: string;
  products: Products[] = [];
  styleClass: any;
}

export class Products {
  product_id: string;
  sync_source: string;
  sync_product_id: string;
  menu_item_id: string;
  weed_product_id: string;
  product_name: string;
  cat_id: string;
  vendor_name: string;
  disp_id: string;
  priority: string;
  parent_id: string;
  variant_id: string;
  thc_percent: string;
  cbd_percent: string;
  cbn_percent: string;
  retail_price: string;
  price: string;
  unlimited: string;
  qty: string;
  sub_qty: string;
  grams_per_eight: string;
  description: string;
  created_at: string;
  updated_at: string;
  status: string;
  hidden_at: string;
  is_deleted: string;
  images: string[];
  attr_name: string;
  categoryName: any;
  variants: Variants[];

}

export class Variants {
  product_id: string;
  unlimited: string;
  parent_id: string;
  variant_id: string;
  variant_type: string;
  variant_qty: string;
  attr_id: string;
  variant_name: string;
  retail_price: string;
  price: string;
  qty: string;
  checked: boolean = true;
}

export class Items {
  product_id: string;
  cat_id: string;
  disp_id: string;
  parent_id: string;
  variant_id: string;
  thc_percent: string;
  cbd_percent: string;
  cbn_percent: string;
  price: string;
  description: string;
  created_at: string;
  updated_at: string;
  status: string;
  hidden_at: string;
  is_deleted: string;
  images: string[];
  category: Category = new Category();
  variants: Variants[] = [];
  dispensary: Dispensary = new Dispensary();
}
